import { defineStore } from 'pinia';
import { ref } from 'vue';

import type { ErrorState } from './types';

/**
 * Error store for centralized error state management.
 *
 * Note: This store only manages error data without i18n.
 * Use the `useError` composable for i18n-integrated error handling.
 */
export const useErrorStore = defineStore('error', () => {
  const error = ref<ErrorState | null>(null);

  /**
   * Set the error state directly.
   * For convenience with default messages, use useError().showError() instead.
   */
  const setError = (errorState: ErrorState) => {
    console.log('[stores/error] Setting error:', errorState);
    error.value = errorState;
  };

  /**
   * Clear the current error.
   */
  const clearError = () => {
    console.trace('[stores/error] Clearing error');
    error.value = null;
  };

  /**
   * Reset store state (alias for clearError for Pinia convention).
   */
  const $reset = () => {
    error.value = null;
  };

  return {
    /** Current error state (reactive) */
    error,
    /** Set error state directly */
    setError,
    /** Clear the current error */
    clearError,
    /** Reset store state */
    $reset,
  };
});
